import React from 'react';
import PropTypes from 'prop-types';

export function SectionRight(props) {
  return <div className={props.className}>{props.children}</div>;
}

SectionRight.propTypes = {
  /**
   * ClassName to set on component
   */
  className: PropTypes.string,
  /**
   * Children to be rendered inside component
   */
  children: PropTypes.oneOfType([PropTypes.element, PropTypes.array]),
};

SectionRight.defaultProps = {};
